import {styled, Typography} from '@mui/material';
import {SectionDivisorProps} from './types';

const IncomeTaxContainer = styled('div')`
	background-color: ${({theme}) => theme.colors.light.background.paper};
	border-radius: 16px;
	padding: 32px 40px;
	width: 100%;

	@media (max-width: 599px) {
		padding: 32px 24px;
	}
`;

const CardTitle = styled(Typography)`
	font-size: 1rem;
	font-weight: 600;
	color: ${({theme}) => theme.colors.light.text.secondary};
`;

const CardSubtitle = styled(Typography)`
	font-size: 0.875rem;
	font-weight: 600;
	color: ${({theme}) => theme.colors.light.text.secondary};
`;

const LineTitle = styled(Typography)`
	font-size: 0.875rem;
	font-weight: 400;
	color: ${({theme}) => theme.colors.light.text.secondary};
`;

const LineText = styled(Typography)`
	font-size: 1rem;
	font-weight: 400;
	color: ${({theme}) => theme.colors.light.text.primary};
`;

const SectionDivisor = styled('div')<SectionDivisorProps>`
	height: 0.0625rem;
	width: 100%;
	background-color: ${({backgroundColor, theme}) =>
		backgroundColor || theme.colors.gray['30Percent']};
	margin-top: 24px;
	margin-bottom: 24px;
`;

const PriceLine = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const TotalPrice = styled(Typography)`
	font-size: 1.25rem;
	font-weight: 600;
	color: ${({theme}) => theme.colors.light.text.primary};
`;

export {
	IncomeTaxContainer,
	CardTitle,
	CardSubtitle,
	LineTitle,
	LineText,
	SectionDivisor,
	PriceLine,
	TotalPrice,
};
